import client from '../httpClient';

const divisionsGetDashboardInitalApi = () => {
  return client.get('/divisions/dashboard/initial-display');
};

export default divisionsGetDashboardInitalApi;
